import Vue from 'vue';
import Router from 'vue-router';
import routers from './routers';

Vue.use(Router);

export const asyncRoutes = routers;
export const constantRoutes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'OA管理系统',
      hideInMenu: true,
    },
    component: () => import('@/view/login/login.vue'),
  },
  {
    path: '/auth/callback',
    name: 'authCallback',
    meta: {
      title: '统一认证回调',
      hideInMenu: true,
    },
    component: () => import('@/view/auth/auth-callback.vue'),
  },
  {
    path: '/aiLogin',
    name: 'aiLogin',
    component: () => import('@/view/ai/login/index.vue'),
    meta: {
      title: 'AI',
      hideInMenu: true,
    },
  },
  {
    path: '/aiMenu',
    name: 'aiMenu',
    component: () => import('@/view/ai/menu/index.vue'),
    meta: {
      title: 'AI 导航',
      hideInMenu: true,
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/view/ai/chat/index.vue'),
    meta: {
      title: 'AI 聊天',
      hideInMenu: true,
    },
  },
  {
    path: '/aiChat',
    name: 'aiChat',
    component: () => import('@/view/ai/chat/indexTemporary.vue'),
    meta: {
      title: 'AI 聊天',
      hideInMenu: true,
    },
  },
  {
    path: '/scorePrinting/result',
    name: 'scorePrintingResult',
    component: () => import('@/view/scorePrinting/printResult.vue'),
    meta: {
      title: '学生成绩打印',
      hideInMenu: true,
    },
  },
  {
    path: '/rfi/repairreportMgmt/repairApplication#/',
    name: 'login2',
    meta: {
      title: 'OA管理系统',
      hideInMenu: true,
    },
    component: () => import('@/view/login/login.vue'),
  },
  {
    path: '/showDoc',
    name: 'doc',
    meta: {
      title: 'OA管理系统',
      hideInMenu: true,
    },
    component: () => import('@/view/DocView/DocView.vue'),
  },
  {
    path: '/dataBoardFull',
    name: 'dataBoardFull',
    component: () => import('@/view/kanban/dataBoard.vue'),
    meta: {
      icon: '_setting',
      title: '集团数据看板',
      hideInMenu: true,
    },
  },
  {
    path: '/groupKanbanFull',
    name: 'groupKanbanFull',
    component: () => import('@/view/kanban/groupKanban.vue'),
    meta: {
      icon: '_setting',
      title: '集团数据看板',
      hideInMenu: true,
    },
  },
  {
    path: '/schlloKanbanFull',
    name: 'schlloKanbanFull',
    component: () => import('@/view/kanban/schlloKanban.vue'),
    meta: {
      icon: '_setting',
      title: '集团数据看板',
      hideInMenu: true,
    },
  },
  {
    path: '/schoolBoardFull',
    name: 'schoolBoardFull',
    component: () => import('@/view/kanban/schoolBoard.vue'),
    meta: {
      icon: '_setting',
      title: '集团数据看板',
      hideInMenu: true,
    },
  },
  {
    path: '/schoolBoard',
    name: 'schoolBoardFull',
    component: () => import('@/view/kanban/schoolBoard.vue'),
    meta: {
      icon: '_setting',
      title: '集团数据看板',
      hideInMenu: true,
    },
  },
];

const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });
// const createRouter = () =>
//   loadMenu().lenght > 0
//     ? new Router({
//         // mode: 'history', // require service support
//         scrollBehavior: () => ({ y: 0 }),
//         routes: [...asyncRoutes, ...loadMenu()],
//       })
//     : new Router({
//         // mode: 'history', // require service support
//         scrollBehavior: () => ({ y: 0 }),
//         routes: [...constantRoutes],
//       });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
